const OurInvester = () => {
    return (
        <>
            <div className={"our-investor"}>
                <p>Our Investors</p>
                <div className={"d-flex"}>
                    <img src={"/images/about-us/tokyo.svg"} alt={"Tokyo Investor"} width={100} height={100} />
                    <img src={"/images/about-us/8vc.svg"} className={"vc"} alt={"8vc Investor"} width={100} height={100} />
                    <img src={"/images/about-us/fin.svg"} className={"fintech"} alt={"fin Investor"} width={100} height={100} />
                    <img src={"/images/about-us/olive.svg"} alt={"olive Investor"} width={100} height={100} />
                    <img src={"/images/about-us/yc.svg"} className={"yc"} alt={"YC Investor"} width={100} height={100} />
                    <img src={"/images/about-us/decent.svg"} alt={"Decent Capital Investor"} width={100} height={100} />
                    <img src={"/images/about-us/begin.svg"} alt={"Begin Capital Investor"} width={100} height={100} />
                </div>
            </div>

        </>
    )
}

export default OurInvester;